// − 값 + 스테퍼 (메트로놈·연습 일지 공용). 버튼을 누르고 있으면 반복 증감한다.
import React, { useEffect, useRef } from 'react';
import { Box, ButtonBase, Typography } from '@mui/material';
import { RemoveRounded, AddRounded } from '@mui/icons-material';

function HoldButton({ onStep, disabled, label, children }) {
  const timers = useRef([]);
  const clear = () => {
    timers.current.forEach((t) => { clearTimeout(t); clearInterval(t); });
    timers.current = [];
  };
  useEffect(() => clear, []);

  const begin = (e) => {
    if (disabled) return;
    e.preventDefault();
    onStep();
    timers.current.push(setTimeout(() => {
      timers.current.push(setInterval(onStep, 70));
    }, 400));
  };

  return (
    <ButtonBase
      aria-label={label}
      disabled={disabled}
      onPointerDown={begin}
      onPointerUp={clear}
      onPointerLeave={clear}
      onPointerCancel={clear}
      onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onStep(); } }}
      sx={{ width: 32, height: 32, color: disabled ? 'text.disabled' : 'text.primary' }}
    >
      {children}
    </ButtonBase>
  );
}

export default function Stepper({ value, min, max, step = 1, onChange, format, label, width = 40 }) {
  const latest = useRef(value);
  latest.current = value;
  const change = (dir) => {
    const next = Math.min(max, Math.max(min, latest.current + dir * step));
    if (next !== latest.current) {
      latest.current = next;
      onChange(next);
    }
  };
  return (
    <Box sx={{ display: 'inline-flex', alignItems: 'center', border: '1px solid', borderColor: 'divider', borderRadius: '10px', flexShrink: 0 }}>
      <HoldButton label={`${label} 줄이기`} disabled={value <= min} onStep={() => change(-1)}>
        <RemoveRounded fontSize="small" />
      </HoldButton>
      <Typography sx={{ minWidth: width, textAlign: 'center', fontWeight: 700, fontSize: '0.875rem', fontVariantNumeric: 'tabular-nums' }}>
        {format ? format(value) : value}
      </Typography>
      <HoldButton label={`${label} 늘리기`} disabled={value >= max} onStep={() => change(1)}>
        <AddRounded fontSize="small" />
      </HoldButton>
    </Box>
  );
}
